import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="bg-amazonia-dark-800 text-white py-8 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Informações do Evento */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className="text-lg font-semibold mb-4 text-golden-400">
              8ª Semana Acadêmica ICSA
            </h3>
            <p className="text-sm text-gray-300 mb-2">
              Instituto de Ciências Sociais Aplicadas
            </p>
            <p className="text-sm text-gray-300 mb-2">
              Universidade Federal do Sul e Sudeste do Pará
            </p>
            <p className="text-sm text-golden-300 font-medium">
              Universidade na Amazônia: Inovação, Sustentabilidade e Saberes na Rota da COP 30
            </p>
          </motion.div>

          {/* Links Úteis */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <h3 className="text-lg font-semibold mb-4 text-golden-400">
              Links Úteis
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://unifesspa.edu.br" target="_blank" rel="noopener noreferrer" 
                   className="text-gray-300 hover:text-golden-300 transition-colors">
                  Site da Unifesspa
                </a>
              </li>
              <li>
                <a href="https://icsa.unifesspa.edu.br/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-golden-300 transition-colors">
                  ICSA - Instituto
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-golden-300 transition-colors">
                  Regulamento do Evento
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-golden-300 transition-colors">
                  Certificados
                </a>
              </li>
            </ul>
          </motion.div>

          {/* Contato */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <h3 className="text-lg font-semibold mb-4 text-golden-400">
              Contato
            </h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p className="flex items-center space-x-2">
                <span>icsa@unifesspa.edu.br</span>
              </p>
              <p className="flex items-center space-x-2">
                <span>(94) 2101-5943</span>
              </p>
              <p className="flex items-center space-x-2">
                <span>Rondon do Pará - PA</span>
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="border-t border-amazonia-green-700 mt-8 pt-6 text-center"
        >
          <p className="text-sm text-gray-400">
            © 2025 ICSA - Unifesspa. Desenvolvido para a 8ª Semana Acadêmica.
          </p>
          <p className="text-xs text-gray-500 mt-2">
            By DevCreate | <a href="https://devcreate.com.br" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-golden-300 transition-colors">devcreate.com.br</a>
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
